export default __webpack_public_path__ + "static/media/1140.f115cf3e.png";